<template>
  <footer class="site-footer">
    <div class="footer-main">
      <div class="footer-columns">
        <div>
          <strong>关于</strong>
          <a href="/#/company">关于美菜</a>
          <a href="/#/download_app">美菜商城</a>
          <a href="/#/information">公司资讯</a>
        </div>
        <div>
          <strong>联系</strong>
          <a href="/#/cooperation">合作共赢</a>
          <a href="/#/driver">司机注册</a>
        </div>
        <div>
          <strong>帮助</strong>
          <a href="/#/download_app#new-guidelines">新手指南</a>
          <a href="/#/help">帮助中心</a>
          <a href="https://material-page.yunshanmeicai.com/richText/1000998" target="_blank">隐私政策</a>
          <a href="https://material-page.yunshanmeicai.com/richText/1000158" target="_blank">售后准则</a>
        </div>
      </div>
      <img class="footer-assurance" src="@/assets/images/baozhang.png" alt="放心消费在社区商家承诺书" />
    </div>

    <div class="footer-legal">
      <p>
        <span>copyright © 2014-{{ copyrightYear }} 北京云杉信息技术有限公司</span>
        <span>4001137137</span>
        <a
          class="footer-license-link"
          href="https://img-oss.yunshanmeicai.com/site/%E4%BA%91%E6%9D%89%E4%BF%A1%E6%81%AF%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.pdf"
          target="_blank"
          >经营证照</a
        >
        <a class="footer-license-link" href="https://www.meicai.cn/#/news/detail/11" target="_blank">打击传销</a>
      </p>
      <p>
        <span>北京市东城区王府井大街88号1幢六层601</span>
        <span>京ICP备14045665号-2</span>
        <span><img src="@/assets/images/new-img/gongan.png" alt="" />京公网安备 11010102004170号</span>
      </p>
      <div class="footer-trust">
        <img src="@/assets/images/new-img/footerIcon1.png" alt="网络警察报警平台" />
        <img src="@/assets/images/new-img/footerIcon2.png" alt="中国互联网举报中心" />
        <img src="@/assets/images/new-img/footerIcon3.png" alt="网络举报平台" />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "HomeFooter",
  data() {
    return { copyrightYear: new Date().getFullYear() };
  }
};
</script>

<style lang="scss" scoped>
.site-footer {
  box-sizing: border-box;
  padding: 48px clamp(40px, 8vw, 116px) 28px;
  background: #252b37;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
}

.footer-main {
  display: grid;
  gap: 50px;
  align-items: flex-start;
  grid-template-columns: minmax(0, 1fr) 210px;
}

.footer-columns {
  display: grid;
  gap: 90px;
  grid-template-columns: repeat(3, 120px);
}

.footer-columns > div {
  display: flex;
  gap: 11px;
  flex-direction: column;
  align-items: flex-start;
}

strong {
  margin-bottom: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

a {
  color: rgba(255, 255, 255, 0.56);
  font-size: 12px;
  line-height: 18px;
  text-decoration: none;
}

a:hover {
  color: #bde66e;
}

.footer-assurance {
  box-sizing: border-box;
  width: 164px;
  height: 220px;
  align-self: end;
  justify-self: end;
  border: 5px solid #fff;
  object-fit: cover;
  object-position: top;
}

.footer-legal {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.42);
  font-size: 10px;
  line-height: 18px;
}

.footer-legal p {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-legal p img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.footer-legal p > span:not(:last-child) {
  margin-right: 12px;
}

.footer-license-link {
  margin: 0;
  color: inherit;
  font-size: inherit;
  line-height: inherit;
}

.footer-license-link:hover {
  color: #bde66e;
}

.footer-license-link + .footer-license-link {
  margin-left: 12px;
}

.footer-trust {
  display: flex;
  margin-top: 14px;
  gap: 8px;
  justify-content: center;
}

.footer-trust img {
  width: 88px;
  height: 31px;
}

@media (max-width: 1080px) {
  .site-footer { padding-right: 28px; padding-left: 28px; }
  .footer-main { grid-template-columns: minmax(0, 1fr) 164px; }
  .footer-columns { gap: clamp(36px, 7vw, 74px); }
  .footer-assurance { width: 144px; height: 194px; }
}

@media (max-width: 720px) {
  .site-footer { padding: 42px 20px 26px; }
  .footer-main { gap: 34px; grid-template-columns: 1fr; }
  .footer-columns { gap: 24px; grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .footer-columns > div { gap: 13px; }
  strong { margin-bottom: 4px; font-size: 13px; }
  a { font-size: 11px; line-height: 1.5; }
  .footer-assurance { display: none; }
  .footer-legal { margin-top: 28px; padding-top: 20px; font-size: 10px; line-height: 1.9; }
  .footer-legal p { display: flex; flex-wrap: wrap; justify-content: center; text-align: center; }
  .footer-legal p + p { margin-top: 6px; }
  .footer-trust { justify-content: center; }
  .footer-trust img { width: 76px; height: 27px; }
}

@media (max-width: 560px) {
  .site-footer { padding-right: 18px; padding-left: 18px; }
  .footer-columns { gap: 17px; }
  .footer-license-link + .footer-license-link { margin-left: 7px; }
  .footer-trust { gap: 6px; }
  .footer-trust img { width: 68px; height: 24px; }
}
</style>
